import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid } from '@tq/ui-components';
import { useIsMobile } from '@tq/ui-components/dist/hooks';

import { ActionMenuButton } from 'components';
import { useNavigate } from 'hooks';
import { Consultation } from 'types';
import { useSummaryMenuOptions } from '../../hooks';

export interface OpenConsultationButtonsProps {
  consultation: Consultation;
}

export const OpenConsultationButtons: React.FC<OpenConsultationButtonsProps> = ({
  consultation,
}) => {
  const { t } = useTranslation('summary_header');
  const options = useSummaryMenuOptions(consultation);
  const { navigateToResponse } = useNavigate();
  const isMobile = useIsMobile();

  return (
    <Grid
      data-testid='open-consultation-buttons'
      gridAutoFlow='column'
      gridTemplateColumns='1fr 1fr'
      gridGap={4}
      w={isMobile ? '100%' : 'inherit'}
    >
      <Box>
        <ActionMenuButton consultationId={consultation.id} options={options} />
      </Box>
      <Button
        minWidth='unset'
        onClick={() => consultation && navigateToResponse(consultation.id)}
      >
        {t('respond', 'Respond')}
      </Button>
    </Grid>
  );
};
